/**
 * @generated SignedSource<<09bd4699cc0540a246e065f32469a70e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TagEditor_updateTags_Mutation$variables = {
  nodeId: string;
  tags: ReadonlyArray<string>;
};
export type TagEditor_updateTags_Mutation$data = {
  readonly updateTags: {
    readonly node: {
      readonly id: string;
      readonly tags?: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly originalName: string;
      }>;
    };
  } | null;
};
export type TagEditor_updateTags_Mutation = {
  response: TagEditor_updateTags_Mutation$data;
  variables: TagEditor_updateTags_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tags"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "nodeId",
        "variableName": "nodeId"
      },
      {
        "kind": "Variable",
        "name": "tags",
        "variableName": "tags"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Tag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HasTagsInterface",
  "abstractKey": "__isHasTagsInterface"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TagEditor_updateTags_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TagsUpdateTagsMutationPayload",
        "kind": "LinkedField",
        "name": "updateTags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TagEditor_updateTags_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TagsUpdateTagsMutationPayload",
        "kind": "LinkedField",
        "name": "updateTags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0d59646daeb01f6a3e2595b35a4647b1",
    "id": null,
    "metadata": {},
    "name": "TagEditor_updateTags_Mutation",
    "operationKind": "mutation",
    "text": "mutation TagEditor_updateTags_Mutation(\n  $nodeId: ID!\n  $tags: [String!]!\n) {\n  updateTags(input: {nodeId: $nodeId, tags: $tags}) {\n    node {\n      __typename\n      id\n      ... on HasTagsInterface {\n        __isHasTagsInterface: __typename\n        tags {\n          id\n          name\n          originalName\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "36cced078afbddb6749c181179ea5f2b";

export default node;
